import css from 'styled-jsx/css'
import { colors, common, sizes } from '../../theme'

export default css`
  .parallax-title {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 0;
  }

  .title {
    ${common.big};
    display: block;
    width: 100%;
    color: ${colors.pureWhite};

    font-family: 'Taviraj-ExtraLight', serif;
    font-weight: 200;
    font-size: 18rem;
    line-height: 1;
    display: flex;
    justify-content: center;
    white-space: nowrap;
    opacity: 0.1;
  }


  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .title {
      font-size: 13rem;
    }
  }

  @media screen and (max-width: ${sizes.media.smallTablet.maxWidth}) {
    .title {
      font-size: 9rem;
    }
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    display: none;
  }
`
